import {connect} from 'react-redux'
import {translateText} from 'actions/language'
import {getLanguageMap, getTargetLanguage} from 'selectors/language'
import TranslatedText from './translatedText'
import {getTranslation} from 'helpers/language'
import {getUser} from 'selectors/auth'

const mapStateToProps = (state, ownProps) => {
  const {children, dataTokens, showOriginal} = ownProps

  const user = getUser(state)
  const targetLanguage = getTargetLanguage(state)
  const languageMap = getLanguageMap(state)

  const translation = getTranslation(user, children, languageMap, targetLanguage, dataTokens, showOriginal)

  return {
    user,
    targetLanguage,
    languageMap,
    translation,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTranslate: (text) => dispatch(translateText(text)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TranslatedText)
